// Components==============
import { useLayoutEffect, useState } from 'react';
// =========================

export function useMeasure(ref?: React.RefObject<HTMLDivElement>) {
  const [bounds, setBounds] = useState({
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
  });

  const element = ref?.current || document.querySelector('body');

  const [resizeO] = useState(
    () =>
      new ResizeObserver(([entry]) => {
        setBounds(entry.contentRect);
      })
  );

  useLayoutEffect(() => {
    if (element) {
      resizeO.observe(element);
    }

    return () => {
      resizeO.disconnect();
    };
  }, [resizeO, element]);

  return bounds;
}
